import { Box, Image, useColorModeValue } from "@chakra-ui/react";

const AuthLogo = () => {
  const src = useColorModeValue("/images/logo.webp", "/images/logo-dark.png");
  const logoSize = useColorModeValue("100%", "77%");

  return (
    <Box
      mx="auto"
      w="100px"
      h="155px"
      borderRadius="12px"
      overflow="hidden"
      _dark={{ mb: "16px" }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Image
        src={src}
        w={logoSize}
        h={logoSize}
        fit="cover"
        objectPosition="top"
      />
    </Box>
  );
};

export default AuthLogo;
